// extracted by mini-css-extract-plugin
export default {"footer":"entering-identifier_footer__K1nVk","placeHolderShimmer":"entering-identifier_placeHolderShimmer__0zuov"};